// Color de identidad del módulo Caja Chica — compartido entre la página y sus
// pestañas (Registro Egresos, Registro de Ingresos, etc.) para que todas usen el mismo
// acento en vez de repetir el hex en cada archivo.
export const CAJA_CHICA_COLOR = "#2e7d32";
